import React, { useState, useContext } from "react";
import "./Emplogin.css";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ThoughtForTheDay from "../../components/ThoughtForTheDay";
import user_avatar from "../../assests/user_avatar.png";
import illustration from "../../assests/illustration (2).png";
import Loginheader from "../../components/loginheader/Loginheader";
import { AuthContext } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import overlay_video from "../../assests/balloons_transparent.gif";


export default function Emplogin() {
    const [showPage, setShowPage] = useState(false);
    const navigate = useNavigate();
    const { login, backUrl } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState(""); // used for OTP also
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [otpSent, setOtpSent] = useState(false); // NEW ✔

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    // =========================
    // NORMAL PASSWORD LOGIN
    // =========================
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = { username, password };

        try {
            const response = await axios.post(`${backUrl}/api/token/`, user);
            await login(response.data);
            const data = response.data;

            if (data.employee !== null) {
                if (data.employee.is_hod === true && data.employee.is_superuser === false) navigate("/hod");
                else if (data.employee.is_hr === true)
                    navigate("/chooserole");
                else navigate("/employee");
            } else toast.error("Employee not found!");
        } catch (error) {
            const errorMessage =
                error?.response?.data?.data || "Login failed. Please try again.";

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // SEND OTP
    // =========================
    const sendOtp = async () => {
        if (!username) {
            toast.error("Enter username");
            return;
        }

        try {
            setLoading(true);
            await axios.post(`${backUrl}/api/auth/otp/generate/`, {
                username: username,
            });

            setOtpSent(true); // NOW OTP FIELD WILL SHOW ✔
            toast.success("OTP sent to your registered mobile");
        } catch {
            toast.error("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const verifyOtp = async () => {
        if (!username || !password) {
            toast.error("Enter OTP");
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(`${backUrl}/api/auth/otp/verify/`, {
                username: username,
                otp: password,
            });

            await login(response.data);
            const data = response.data;

            if (data.employee) {
                const emp = data.employee;

                // ALL TRUE → chooserole
                if (emp.is_hr && emp.is_hod && emp.is_superuser) {
                    navigate("/chooserole");
                    return;
                }

                // ONLY HOD
                if (
                    emp.is_hod === true &&
                    emp.is_hr === false &&
                    emp.is_superuser === false
                ) {
                    navigate("/hod");
                    return;
                }

                // HR or Superuser (but not all three)
                if (emp.is_hr || emp.is_superuser) {
                    navigate("/chooserole");
                    return;
                }

                // Default
                navigate("/employee");
            }

            else toast.error("Employee not found");
        } catch {
            toast.error("Invalid OTP");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            {showPage ? (
                <ThoughtForTheDay />
            ) : (
                <>
                    <Loginheader />
                    <div className="login-container">
                        <div className="login-box">
                            {!isMobile && (
                                <div className="login-right">
                                    <img
                                        src={illustration}
                                        alt="Illustration"
                                        className="illustration"
                                    />
                                </div>
                            )}

                            <div className="login-left">
                                {isMobile ? <h4>BEMSS</h4> : <h2 className="login-title">BEMSS</h2>}

                                <div className="login-avatar">
                                    <img src={user_avatar} alt="User" />
                                </div>

                                {isMobile ? <p>Sign In</p> : <h3>Sign In</h3>}

                                {/* =====================================================
                                       NORMAL LOGIN   OR   OTP LOGIN (same layout)
                                   ===================================================== */}
                                {!showOtp ? (
                                    // ============= NORMAL LOGIN FORM ============
                                    <form onSubmit={handleSubmit}>
                                        <div className="input-group">
                                            <div className="input-wrapper">
                                                <FaUser className="input-icon" />
                                                <input
                                                    style={{ width: `240px` }}
                                                    type="text"
                                                    placeholder="Username"
                                                    value={username}
                                                    onChange={(e) => setUsername(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="input-group">
                                            <div className="input-wrapper">
                                                <FaLock className="input-icon" />
                                                <input
                                                    style={{ width: `200px` }}
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <span
                                                    className="password-toggle"
                                                    style={{ paddingRight: "12px" }}
                                                    onClick={togglePasswordVisibility}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                            </div>
                                        </div>

                                        <button className="login-btn" type="submit" disabled={loading}>
                                            {loading ? <div className="spinner"></div> : "Sign In"}
                                        </button>

                                        <br />
                                        <center>
                                            <a onClick={() => setShowOtp(true)}>Login With OTP ?</a>
                                        </center>
                                        {/* <img
                                            src={overlay_video}
                                            alt=""
                                            aria-hidden="true"
                                            className="balloons-overlay"
                                        /> */}
                                    </form>
                                ) : (
                                    // ============ OTP LOGIN (same layout) ============
                                    <>
                                        <center>
                                            <div className="input-group">



                                                <div className="input-wrapper">
                                                    <FaUser className="input-icon" />
                                                    <input
                                                        style={{ width: `240px` }}
                                                        type="text"
                                                        placeholder="Username"
                                                        value={username}
                                                        onChange={(e) => setUsername(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            {/* OTP FIELD only after SEND OTP */}
                                            {otpSent && (
                                                <div className="input-group">
                                                    <div className="input-wrapper">
                                                        <FaLock className="input-icon" />
                                                        <input
                                                            style={{ width: `240px` }}
                                                            type="text"
                                                            placeholder="Enter OTP"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {/* Send OTP button (verify only when otp sent) */}
                                            {!otpSent ? (
                                                <button
                                                    className="login-btn"
                                                    onClick={sendOtp}
                                                    disabled={loading}
                                                    style={{ width: `240px` }}
                                                >
                                                    {loading ? <div className="spinner"></div> : "Send OTP"}
                                                </button>
                                            ) : (
                                                <button
                                                    className="login-btn"
                                                    onClick={verifyOtp}
                                                    disabled={loading}
                                                    style={{ width: `240px` }}
                                                >
                                                    {loading ? <div className="spinner"></div> : "Verify OTP"}
                                                </button>
                                            )}
                                        </center>
                                        {/* USERNAME same layout */}


                                        <br />
                                        <center>
                                            <a
                                                onClick={() => {
                                                    setShowOtp(false);
                                                    setOtpSent(false);
                                                    setPassword("");
                                                }}
                                            >
                                                Back to Password Login
                                            </a>
                                        </center>
                                    </>
                                )}
                                
                            </div>

                        </div>
                    </div>
<img
                                    src={overlay_video}
                                    alt=""
                                    aria-hidden="true"
                                    className="balloons-overlay"
                                />

                                <img
                                    src={overlay_video}
                                    alt=""
                                    aria-hidden="true"
                                    className="balloons-overlay2"
                                />
                </>
            )}
        </>
    );
}
